import React from 'react';
import { Box, Button, Stack, TextField, Typography } from '@mui/material';

const PointForm = ({ values, errors, onChange, onSubmit, isSubmitting }) => {
  return (
    <Box component="form" onSubmit={onSubmit}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Добавить точку
      </Typography>

      <Stack spacing={2}>
        <TextField
          label="Название"
          value={values.name}
          onChange={onChange('name')}
          error={Boolean(errors.name)}
          helperText={errors.name}
          required
          fullWidth
        />

        <TextField
          label="Координаты"
          value={values.coordinates}
          onChange={onChange('coordinates')}
          placeholder="55.751244, 37.618423"
          error={Boolean(errors.coordinates)}
          helperText={errors.coordinates || 'Формат: latitude, longitude'}
          required
          fullWidth
        />

        <Button type="submit" variant="contained" disabled={isSubmitting}>
          {isSubmitting ? 'Добавление...' : 'Добавить'}
        </Button>
      </Stack>
    </Box>
  );
};

export default PointForm;
